import { render } from "./SynergyItsProductComp.vue?vue&type=template&id=47c83ddc&scoped=true"
import script from "./SynergyItsProductComp.vue?vue&type=script&lang=js"
export * from "./SynergyItsProductComp.vue?vue&type=script&lang=js"

import "./SynergyItsProductComp.vue?vue&type=style&index=0&id=47c83ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c83ddc"]])

export default __exports__